var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search",
    width: "49px",
    height: "50px",
    viewBox: "0 0 49 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "search-1",
    d: "M18.5,0 C28.4411255,0 36.5,8.0588745 36.5,18 C36.5,21.8031245 35.3205369,25.3307706 33.3074434,28.2371056 L48.7279221,43.6568542 L43.0710678,49.3137085 L27.4051843,33.6463843 C24.7791626,35.1442146 21.739521,36 18.5,36 C8.5588745,36 0.5,27.9411255 0.5,18 C0.5,8.0588745 8.5588745,0 18.5,0 Z M18.5,6 C11.872583,6 6.5,11.372583 6.5,18 C6.5,24.627417 11.872583,30 18.5,30 C25.127417,30 30.5,24.627417 30.5,18 C30.5,11.372583 25.127417,6 18.5,6 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search-3",
    transform: "translate(-8.000000, -9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search-4",
    transform: "translate(8.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "search-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    id: "search-6",
    xlinkHref: "#search-1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "search-7",
    stroke: "#151515",
    strokeWidth: 6,
    d: "M29.289,28.419 L29.2688032,28.4411969 L44.4852312,43.6569045 L43.0711654,45.0709703 L27.7837977,29.7821968 L27.7837977,29.7821968 L28.0055,29.6042578 C28.3888534,29.2898682 28.756348,28.9568554 29.1066017,28.6066017 L29.289,28.419 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "search-8",
    className: "fill-selector",
    mask: "url(#search-5)",
    fill: "#151515"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search-9",
    transform: "translate(-8.000000, -9.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "search-10",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5d00c6933e1f5d5907f28c66050ea807.svg";
export { ForwardRef as ReactComponent };